export default __webpack_public_path__ + "static/media/M13 - Black Dragon.6acbb9a0.png";